class DropdownManager {
  private currentZIndex = 10000;
  private openDropdowns: Set<string> = new Set();

  getNextZIndex(id: string): number {
    this.openDropdowns.add(id);
    this.currentZIndex += 10;
    return this.currentZIndex;
  }

  releaseZIndex(id: string): void {
    this.openDropdowns.delete(id);
    if (this.openDropdowns.size === 0) {
      this.currentZIndex = 10000;
    }
  }
}

export const dropdownManager = new DropdownManager();